import React from "react";

const Svg = ({width = 15}: {width?: number} = {}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1807_2691)">
        <path
          d="M15.001 7.50065C15.001 11.6432 11.6428 15.0013 7.50033 15.0013C3.35783 15.0013 0 11.6428 0 7.50065C0 3.35848 3.35816 0 7.50065 0C11.6432 0 15.0013 3.35816 15.0013 7.50065H15.001ZM7.651 12.1933C8.41121 11.3187 9.10586 10.4375 9.73399 9.47602C10.2258 8.72299 10.8986 7.5649 10.9752 6.70783C11.0776 5.56018 10.626 4.42754 9.79171 3.65591C8.49241 2.4538 6.53368 2.4476 5.22851 3.64222C4.38416 4.41514 3.92106 5.55138 4.02542 6.70816C4.10434 7.58121 4.79932 8.7706 5.3045 9.5357C5.92871 10.4812 6.61652 11.3513 7.35911 12.2031C7.42891 12.2833 7.57142 12.2846 7.651 12.1933Z"
          fill="black"
        />
        <path
          d="M7.50041 7.60873C8.31976 7.60873 8.98397 6.94451 8.98397 6.12516C8.98397 5.30582 8.31976 4.6416 7.50041 4.6416C6.68106 4.6416 6.01685 5.30582 6.01685 6.12516C6.01685 6.94451 6.68106 7.60873 7.50041 7.60873Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1807_2691">
          <rect width="15.001" height="15.001" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Svg;
